import React from "react";
import { useState } from "react";
import EmptyModal from "./emptyModal";

const modalId = "deleteModal";

export let setModalData: (args: {
	title: string | JSX.Element;
	message: string | JSX.Element;
	buttons: JSX.Element;
}) => void;

export const popup = () => {
	($(`#${modalId}`) as any).modal();
	return;
};

export const hide = () => {
	($(`#${modalId}`) as any).modal("hide");
	return;
};

export default function DeleteModal() {
	const [data, setData] = useState({
		title: "",
		message: "",
		buttons: <button>Default Button</button>
	});
	setModalData = setData as any;

	return (
		<EmptyModal
			id={modalId}
			title={data.title}
			message={data.message}
			buttons={data.buttons}
		/>
	);
}
